import Helmet from "react-helmet";
import { useLocation } from "react-router-dom";
import { URL_ID } from "constants/constants";
import { useEffect, useContext } from "react";
import axios from "axios";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
// داینامیک ها:
// رزرو تور  - ساخت تور - گزارش کاربر
export default function withPageTitle({ children }) {
  const auth = useContext(AuthenticationContext);
  const { pathname: currentPath } = useLocation();
  let title = "",
    description = "";
  for (const key in URL_ID) {
    if (URL_ID[key].route == currentPath) {
      title = URL_ID[key].name;
    }
  }
  useEffect(() => {
    let FD = new FormData();
    FD.append("title", title);
    FD.append("route", currentPath);
    FD.append("user_token", auth.userInfo.token);
    FD.append("mtm", Math.floor(Date.now() / 1000));
    FD.append("uid", 4);

    axios.post("http://mvc.dade24.ir/api/Insert_visits", FD).then(({ data }) => {});
  });
  return (
    <>
      <Helmet>
        <title>{title} | جمه صب</title>
        <description>hhhh</description>
      </Helmet>
      {children}
    </>
  );
}
